module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hello i18n in SFC!"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"hello":"Hello i18n in SFC!"}}')
  delete Component.options._Ctor
  
}
